module.exports = __webpack_public_path__ + "img/Wosslogo2.f238a4d6.png";